import React, { useState, useCallback } from "react";
import { Card, CardBody, CardHeader, Divider, Button, Modal, ModalContent, ModalBody, ModalFooter, ModalHeader, Chip, Textarea } from "@nextui-org/react";
import { getFetcher, getSelectFetcher, postFetcher } from "../../../../services/api";
import { useForm } from "react-hook-form";
import { Tabs, Tab } from "@nextui-org/react";
import useSWR from "swr";
import ControlledReactSelect from "../../../../components/elements/ControlledReactSelect";
import RootAdmin from "../../../../components/layouts/RootAdmin";
import ControlledInput from "../../../../components/elements/ControlledInput";
import toast from "react-hot-toast";
import useAuth from "../../../../hooks/useAuth";
import RoleAccess from "../../../../enums/roles";
import ClientDataGrid from "../../../../components/elements/ClientDataGrid";
import { ArrowPathIcon, MinusIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import getErrorMessage from "../../../../services/errorMessage";

export default function IndexUserStokB3() {
  const { user, roles } = useAuth();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectedTab, setSelectedTab] = useState("current");
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenUpdateModal, setIsOpenUpdateModal] = useState(false);
  const [selectedB3, setSelectedB3] = useState(null); // Data B3 yang dipilih untuk update
  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [formData, setFormData] = useState(null);
  const isSuperAdmin = roles.includes(RoleAccess.SUPER_ADMIN); // Cek apakah user adalah Super Admin
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0); // 0-based untuk MUI DataGrid
  const [isOpenHapusModal, setIsOpenHapusModal] = useState(false);
  const [stokDihapus, setStokDihapus] = useState(null);
  const [alasanHapus, setAlasanHapus] = useState("");
  const [sedangMenghapus, setSedangMenghapus] = useState(false);
  

  const handleSearchChange = useCallback((event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(0); // Reset ke halaman pertama saat search berubah
  }, []);
  
  const getFilteredData = useCallback((dataList) => {
    if (!dataList || !Array.isArray(dataList)) return [];
    if (!searchQuery) return dataList;

    const query = searchQuery.trim().toLowerCase();
    
    // Cek apakah karakter pertama adalah angka
    const startsWithDigit = /^\d/.test(query);

    if (startsWithDigit) {
      // Jika angka: minimal 2 digit untuk mencari CAS Number
      if (query.length >= 2) {
        return dataList.filter((item) => {
          const cas = item?.dataBahanB3?.casNumber || item?.casNumber || "";
          return cas.toLowerCase().includes(query);
        });
      }
    } else {
      // Jika huruf: minimal 3 huruf untuk mencari Nama Perusahaan
      if (query.length >= 3) {
        return dataList.filter((item) => {
          const company = item?.company?.name || item?.companyName || item?.namaPerusahaan || "";
          return company.toLowerCase().includes(query);
        });
      }
    }

    // Mengembalikan data asli jika belum memenuhi syarat panjang karakter
    return dataList;
  }, [searchQuery]);

  const { control, register, handleSubmit, reset, watch, setValue } = useForm({
    defaultValues: {
      startDate: "",
      endDate: "",
      bahanB3Id: null,
      companyId: [],
    },
  });
  const {
    data: currentStokData,
    isLoading: isLoadingCurrentStok,
    mutate,
  } = useSWR(isSuperAdmin ? `/api/data-bahan-b3-company/search?returnAll=true` : `/api/data-bahan-b3-company/search?companyIds=${user.companies.map((company) => company.companyId).join(",")}&returnAll=true`, getFetcher);
  const { data: bahanB3Options, isLoading: isLoadingBahanB3Options } = useSWR(`/api/data-master/bahan-b3?returnAll=true`, getFetcher); // Fetch Bahan B3 options
  const { data: allCompanies } = useSWR(isSuperAdmin ? `/api/company/search-company?returnAll=true` : `/api/company/search-company?companyIds=${user.companies.map((company) => company.companyId).join(",")}`, getSelectFetcher);

  const { 
    data: historyRequestData, 
    isLoading: isLoadingHistoryRequest,
  } = useSWR(
    isSuperAdmin ? `/api/data-bahan-b3-company/search-pending-requests` : `/api/data-bahan-b3-company/search-pending-requests?companyIds=${user.companies.map((company) => company.companyId).join(",")}`,
    getFetcher
  );
  const filters = watch();

  /*
   * Riwayat penghapusan milik perusahaan sendiri. Perusahaan yang boleh terbaca
   * tetap ditentukan server dari tautan pengguna; companyIds di sini hanya
   * mempersempit, sama seperti tab lain di halaman ini.
   */
  const {
    data: riwayatPenghapusanData,
    isLoading: isLoadingRiwayatPenghapusan,
    mutate: mutateRiwayatPenghapusan,
  } = useSWR(
    isSuperAdmin
      ? `/api/data-bahan-b3-company/riwayat-penghapusan-perusahaan?returnAll=true`
      : `/api/data-bahan-b3-company/riwayat-penghapusan-perusahaan?returnAll=true&companyIds=${user.companies.map((company) => company.companyId).join(",")}`,
    getFetcher
  );

  const {
    data: stokPerPeriodData,
    isLoading: isLoadingStokPerPeriod,
    mutate: mutateStokByPeriodData,
  } = useSWR(
    selectedTab === "period" && filters.startDate && filters.endDate
      ? // ? `/api/data-bahan-b3-company/search-period?startDate=${filters.startDate}&endDate=${filters.endDate}&companyId=${filters.companyId?.join(",") || ""}&dataBahanB3Id=${filters.bahanB3Id || ""}`
        `/api/data-bahan-b3-company/search-period`
      : null,
    getFetcher
  );

  const handleOpenModal = () => {
    setIsOpenModal(true);
  };

  const handleCloseModal = () => {
    reset();
    setIsOpenModal(false);
  };

  const handleConfirmSubmit = (data, actionType) => {
    setFormData(data);
    setConfirmAction(actionType);
    setIsOpenConfirmModal(true);
  };

  const onSubmitRequest = async (data) => {
    handleConfirmSubmit(data, "request");
  };

const executeSubmit = async () => {
    try {
      if (confirmAction === "request") {
        const payload = {
          companyId: formData.companyId,
          dataBahanB3Id: formData.bahanB3Id,
          stokB3: formData.stokRequest,
        };
        await postFetcher("/api/data-bahan-b3-company/add-request", payload);
        toast.success("Request stok berhasil diajukan!");
        
        // Refresh kedua tabel secara otomatis!
        mutate(); 
        
        handleCloseModal();
      } else if (confirmAction === "update") {
        const payload = {
          dataBahanB3CompanyId: formData.id,
          companyId: formData?.companyId,
          newStokB3: hitungSelisihStok(formData),
          notes: formData.notes || null,
        };
        
        // TETAP gunakan endpoint yang sama karena backend sudah diatur auto-approve
        await postFetcher("/api/data-bahan-b3-company/update-request", payload); 
        
        // Ubah pesan sukses agar sesuai dengan hasil (bukan lagi sekadar pengajuan)
        toast.success("Stok berhasil diperbarui!");
        
        // Panggil mutate() agar UI/Tabel langsung menarik data terbaru dari database
        // Refresh kedua tabel secara otomatis!
        mutate(); 
        
        handleCloseUpdateModal();
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Gagal memproses permintaan";
      toast.error(errorMessage);
    } finally {
      setIsOpenConfirmModal(false);
      setFormData(null);
      setConfirmAction(null);
    }
  };

  const handleCancelConfirm = () => {
    setIsOpenConfirmModal(false);
    setFormData(null);
    setConfirmAction(null);
  };

  const columnsCurrent = [
    { field: "casNumber", headerName: "CAS Number Bahan Kimia", valueGetter: (row, value) => value.dataBahanB3.casNumber || "N/A" },
    { field: "bahanB3Name", headerName: "Nama Bahan Kimia", valueGetter: (row, value) => value.dataBahanB3.namaBahanKimia || "N/A" },
    { field: "companyName", headerName: "Perusahaan", valueGetter: (row, value) => value.company.name || "N/A" },
    { field: "stok", headerName: "Stok (kg)", valueGetter: (row, value) => value?.stokB3 || 0 },
    //{ field: "stokB3Awal", headerName: "Stok Awal (kg)", valueGetter: (row, value) => value?.stokB3Awal || 0 },
    {
      field: "action",
      headerName: "Aksi",
      minWidth: 260,
      renderCell: (params) => (
        <div className="flex flex-row items-center gap-2">
          <Button size="sm" color="primary" onPress={() => handleOpenUpdateModal(params.row)} startContent={<ArrowPathIcon className="size-4" />}>
            Update Stok
          </Button>
          <Button size="sm" color="danger" variant="flat" onPress={() => handleOpenHapusModal(params.row)} startContent={<TrashIcon className="size-4" />}>
            Hapus Stok
          </Button>
        </div>
      ),
    },
  ];

  const columnsHistoryRequest = [
    { field: "casNumber", headerName: "CAS Number Bahan Kimia", valueGetter: (row, value) => value.dataBahanB3.casNumber || "N/A" },
    { field: "bahanB3Name", headerName: "Nama Bahan Kimia", valueGetter: (row, value) => value.dataBahanB3.namaBahanKimia || "N/A" },
    { field: "type", headerName: "Tipe Pengajuan", valueGetter: (row, value) => (value.type === "create" ? "Request Stok" : "Request Update Stok") },
    { field: "companyName", headerName: "Perusahaan", valueGetter: (row, value) => value.company.name || "N/A" },
    { field: "requestedStok", headerName: "Jumlah Request (kg)", valueGetter: (row, value) => value.requestedStokB3 || "N/A" },
    {
      field: "tanggalPengajuan",
      headerName: "Tanggal Pengajuan",
      renderCell: (params) => {
        const date = params?.row?.requestDate;
        if (!date) return "-";

        const formattedDate = new Intl.DateTimeFormat("id-ID", {
          year: "numeric",
          month: "long",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }).format(new Date(date));

        return formattedDate;
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => {
        const status = params?.row?.approved || false; // Mengambil nilai dari params.value
        return (
          <Chip color={status === true ? "success" : "warning"} variant="flat" size="sm">
            {status === true ? "Disetujui" : "Menunggu Persetujuan"}
          </Chip>
        );
      },
    },
  ];

  const columnsRiwayatPenghapusan = [
    { field: "casNumber", headerName: "CAS Number Bahan Kimia", minWidth: 190 },
    { field: "namaBahanKimia", headerName: "Nama Bahan Kimia", minWidth: 200 },
    {
      field: "stokTerakhir",
      headerName: "Stok Sebelumnya (kg)",
      minWidth: 170,
      renderCell: (params) => `${params?.row?.stokTerakhir ?? 0}`,
    },
    { field: "alasan", headerName: "Alasan Penghapusan", minWidth: 300 },
    {
      field: "dihapusPada",
      headerName: "Waktu Penghapusan",
      minWidth: 220,
      renderCell: (params) => {
        const waktu = params?.row?.dihapusPada;
        if (!waktu) return "-";

        return new Intl.DateTimeFormat("id-ID", {
          year: "numeric",
          month: "long",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }).format(new Date(waktu));
      },
    },
  ];

  const columnsStokPerPeriod = [
    { field: "bahanB3Name", headerName: "Nama B3" },
    { field: "stok", headerName: "Stok (kg)" },
    { field: "companyName", headerName: "Perusahaan" },
    { field: "periode", headerName: "Periode" },
  ];

  /*
   * Penghapusan stok tidak bisa dibatalkan dari layar mana pun: barisnya
   * dibuang, hanya catatan alasannya yang tersimpan. Karena itu formulirnya
   * menampilkan ulang identitas bahan beserta stok terakhir, supaya yang
   * dihapus benar-benar terlihat sebelum ditekan.
   */
  const handleOpenHapusModal = (row) => {
    /*
     * Stok yang belum kosong ditolak di sini supaya tidak perlu bolak-balik ke
     * server untuk sesuatu yang sudah terlihat di barisnya. Syarat kedua -
     * bahan tidak sedang dilaporkan pada periode berjalan - hanya bisa dinilai
     * server, jadi itu ditangani lewat pesan galat dari server.
     */
    const stokSekarang = Number(row?.stokB3 ?? 0);
    if (Math.abs(stokSekarang) > 0.000001) {
      toast.error(`Stok B3 ini masih ${stokSekarang} kg. Stok hanya bisa dihapus jika sudah 0 - kosongkan dulu lewat Update Stok.`);
      return;
    }

    setStokDihapus({
      id: row?.id,
      casNumber: row?.dataBahanB3?.casNumber || "-",
      namaBahanKimia: row?.dataBahanB3?.namaBahanKimia || "-",
      namaPerusahaan: row?.company?.name || "-",
      stokTerakhir: row?.stokB3 ?? 0,
    });
    setAlasanHapus("");
    setIsOpenHapusModal(true);
  };

  const handleCloseHapusModal = () => {
    setIsOpenHapusModal(false);
    setStokDihapus(null);
    setAlasanHapus("");
  };

  const handleHapusStok = async () => {
    if (alasanHapus.trim().length < 5) {
      toast.error("Alasan penghapusan harus diisi, minimal 5 karakter.");
      return;
    }

    try {
      setSedangMenghapus(true);
      await postFetcher("/api/data-bahan-b3-company/hapus-stok", {
        dataBahanB3CompanyId: stokDihapus?.id,
        alasan: alasanHapus.trim(),
      });
      toast.success("Stok B3 dihapus dan alasannya tercatat.");
      mutate();
      mutateRiwayatPenghapusan();
      handleCloseHapusModal();
    } catch (error) {
      toast.error(getErrorMessage(error, "Gagal menghapus stok B3"));
    } finally {
      setSedangMenghapus(false);
    }
  };

  const handleOpenUpdateModal = async (data) => {
    try {
      const response = await getFetcher(`/api/data-bahan-b3-company/detail/${data.id}`);

      setSelectedB3({
        casNumber: response.dataBahanB3?.casNumber || "N/A",
        bahanB3Name: response.dataBahanB3?.namaBahanKimia || "N/A",
        companyName: response.company?.name || "N/A",
        existingStok: response.stokB3 || 0,
        hasPendingRequest: response.updateRequests.length > 0, // Cek apakah ada request yang belum selesai
        stokHistory: response.stokHistory || [], // Riwayat stok
      });

      reset({
        companyId: response.companyId,
        id: response.id,
        casNumber: response.dataBahanB3?.casNumber || "",
        bahanB3Name: response.dataBahanB3?.namaBahanKimia || "",
        companyName: response.company?.name || "",
        existingStok: response.stokB3 || 0,
        // Kolom "Update Stok Menjadi" berangkat dari stok yang sekarang, jadi
        // pengguna tinggal menaikkan atau menurunkannya.
        stokBaru: response.stokB3 || 0,
        stokRequest: "",
        notes: "",
      });
      mutate();
      setIsOpenUpdateModal(true);
    } catch (error) {
      toast.error("Gagal mengambil data stok.");
    }
  };

  const handleCloseUpdateModal = () => {
    setIsOpenUpdateModal(false);
    setSelectedB3(null); // Menghapus data yang dipilih
  };

  /*
   * Server menerima SELISIH stok, bukan nilai akhirnya: approveRequest
   * menjumlahkan requestedStokB3 ke stok yang ada. Layar memakai nilai akhir
   * karena itu yang dipikirkan pengguna, jadi selisihnya dihitung di sini.
   */
  const hitungSelisihStok = (data) => Number(data?.stokBaru ?? 0) - Number(data?.existingStok ?? 0);

  /** Bulatkan ke 3 angka di belakang koma supaya 0.1 + 0.2 tidak jadi 0.30000000000000004. */
  const ubahStokBaru = (langkah) => {
    const sekarang = Number(watch("stokBaru") ?? 0);
    const hasil = Math.max(0, Math.round((sekarang + langkah) * 1000) / 1000);
    setValue("stokBaru", hasil, { shouldValidate: true });
  };

  const onSubmitUpdateRequest = async (data) => {
    try {
      // Siapkan payload untuk API
      const selisih = hitungSelisihStok(data);

      if (selisih === 0) {
        toast.error("Stoknya belum berubah. Naikkan atau turunkan dulu nilainya.");
        return;
      }

      const payload = {
        dataBahanB3CompanyId: data.id,
        companyId: data?.companyId, // ID perusahaan
        newStokB3: selisih, // Server menjumlahkannya ke stok yang ada
        notes: data.notes || null, // Catatan tambahan (opsional)
      };

      // Kirim data ke endpoint API
      await postFetcher("/api/data-bahan-b3-company/update-request", payload);

      // Tampilkan notifikasi sukses
      toast.success("Pembaruan stok berhasil dilakukan.");

      // Tarik ulang daftarnya: tanpa ini angka di tabel masih yang lama,
      // padahal pengguna baru saja melihat nilai barunya di formulir.
      mutate();

      // Tutup modal
      handleCloseUpdateModal();
    } catch (error) {
      // Tampilkan notifikasi error
      toast.error("Gagal mengajukan permintaan pembaruan stok.");
    }
  };

  return (
    <RootAdmin>
      <Card className="w-full mt-5" radius="sm">
        <CardHeader>Daftar Stok B3</CardHeader>
        <Divider />
        <CardBody>
{/* Tambahkan flex, items-center, dan gap-4 untuk memberi jarak sejajar */}
          <div className="pb-5 flex flex-row items-center gap-4">
            <Button size="sm" color="primary" onPress={handleOpenModal} startContent={<PlusIcon className="size-4" />}>
              Request Stok
            </Button>
            
            {/* Search Field di sebelah kanan */}
            <div className="w-[800px]">
              <SearchField 
                value={searchQuery} 
                onChange={handleSearchChange} 
                placeholder="Cari CAS Number atau Perusahaan..." 
              />
            </div>
          </div>
          <Tabs
            color="primary"
            variant="underlined"
            aria-label="tabs"
            classNames={{
              tabList: "gap-6 w-full relative rounded-none p-0 border-b border-divider",
              cursor: "w-full",
              tab: "max-w-fit px-1.5 h-12",
              tabContent: "group-data-[selected=true]:font-semibold",
            }}
            value={selectedTab}
            onValueChange={setSelectedTab}
          >
            <Tab title="Stok Saat Ini" value="current">
              <div className="h-[530px]">
                <ClientDataGrid
                  rows={getFilteredData(currentStokData?.data || [])} 
                  columns={columnsCurrent}
                  rowCount={currentStokData?.totalCount || 0}
                  isLoading={isLoadingCurrentStok}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  page={page}
                  setPage={setPage}
                  clientPagination
                />
              </div>
            </Tab>
            <Tab title="Riwayat Request B3" value="history">
              <div className="h-[530px]">
                <ClientDataGrid
                  rows={getFilteredData(historyRequestData || [])}
                  columns={columnsHistoryRequest}
                  rowCount={historyRequestData?.total || 0}
                  isLoading={isLoadingHistoryRequest}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  page={page}
                  setPage={setPage}
                  clientPagination
                />
              </div>
            </Tab>
            <Tab title="Riwayat Penghapusan B3" value="deletion">
              <div className="h-[530px]">
                <ClientDataGrid
                  rows={getFilteredData(riwayatPenghapusanData?.data || [])}
                  columns={columnsRiwayatPenghapusan}
                  rowCount={riwayatPenghapusanData?.total || 0}
                  isLoading={isLoadingRiwayatPenghapusan}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  page={page}
                  setPage={setPage}
                  clientPagination
                />
              </div>
            </Tab>
            <Tab title="Stok B3 per Periode" value="period">
              <div className="h-[530px]">
                <ClientDataGrid
                  rows={getFilteredData(stokPerPeriodData?.data || [])}
                  columns={columnsStokPerPeriod}
                  rowCount={stokPerPeriodData?.total || 0}
                  isLoading={isLoadingStokPerPeriod}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  page={page}
                  setPage={setPage}
                  clientPagination
                />
              </div>
            </Tab>
          </Tabs>
        </CardBody>
      </Card>

      <Modal isOpen={isOpenModal} onClose={handleCloseModal}>
        <ModalContent>
          <ModalHeader>Request Stok</ModalHeader>
          <ModalBody>
            <form onSubmit={handleSubmit(onSubmitRequest)} className="flex flex-col gap-3">
              <ControlledReactSelect
                control={control}
                name="bahanB3Id"
                label="Pilih Bahan B3"
                isLoading={isLoadingBahanB3Options}
                options={bahanB3Options?.data?.map((bahanB3) => ({ value: bahanB3.id, label: `${bahanB3.casNumber} - ${bahanB3.namaBahanKimia}` })) || []}
              />
              <ControlledReactSelect control={control} name="companyId" label="Pilih Perusahaan" options={allCompanies || []} />
              <ControlledInput {...register("stokRequest")} control={control} type="number" placeholder="Jumlah Stok (kg)" label="Jumlah Stok (kg)" name="stokRequest" required />
              <div className="flex justify-end gap-3 mt-4">
                <Button type="submit" color="primary">
                  Submit
                </Button>
                <Button onPress={handleCloseModal} variant="faded" color="danger">
                  Batal
                </Button>
              </div>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenUpdateModal} onClose={handleCloseUpdateModal}>
        <ModalContent>
          <ModalHeader>Request Update Stok</ModalHeader>
          <ModalBody>
            <form onSubmit={handleSubmit(onSubmitUpdateRequest)} className="flex flex-col gap-3">
              {/* CAS Number */}
              <ControlledInput {...register("casNumber")} control={control} type="text" placeholder="CAS Number" label="CAS Number" name="casNumber" readOnly className="input" isDisabled />
              {/* Nama Bahan B3 */}
              <ControlledInput {...register("bahanB3Name")} control={control} type="text" placeholder="Nama Bahan B3" label="Nama Bahan B3" name="bahanB3Name" readOnly className="input" isDisabled />
              {/* Nama Perusahaan */}
              <ControlledInput {...register("companyName")} control={control} type="text" placeholder="Nama Perusahaan" label="Nama Perusahaan" name="companyName" readOnly className="input" isDisabled />
              {/* Stok Saat Ini */}
              <ControlledInput {...register("existingStok")} control={control} type="number" placeholder="Stok Saat Ini (kg)" label="Stok Saat Ini (kg)" name="existingStok" readOnly className="input" isDisabled />
              {/* Stok yang dituju, lengkap dengan tombol naik-turun */}
              <div className="flex flex-row items-end gap-2">
                <Button isIconOnly variant="flat" className="mb-[2px]" onPress={() => ubahStokBaru(-1)} aria-label="Kurangi stok">
                  <MinusIcon className="size-4" />
                </Button>
                <div className="flex-1">
                  <ControlledInput
                    {...register("stokBaru")}
                    rules={{
                      required: "Jumlah stok harus diisi.",
                      validate: (value) => Number(value) >= 0 || "Stok tidak boleh kurang dari 0.",
                    }}
                    control={control}
                    type="number"
                    placeholder="Stok setelah diperbarui (kg)"
                    label="Update Stok Menjadi (kg)"
                    name="stokBaru"
                    required
                    className="input"
                  />
                </div>
                <Button isIconOnly variant="flat" className="mb-[2px]" onPress={() => ubahStokBaru(1)} aria-label="Tambah stok">
                  <PlusIcon className="size-4" />
                </Button>
              </div>
              {/* Notes */}
              <ControlledInput
                {...register("notes")}
                rules={{
                  required: "Notes harus diisi.",
                }}
                control={control}
                type="text"
                placeholder="Catatan Tambahan"
                label="Notes"
                name="notes"
                className="input"
              />
              {/* Pending Request Flag */}
              {/* selectedB3?.hasPendingRequest && <p className="text-red-500 text-sm">Ada permintaan pembaruan stok yang masih menunggu persetujuan untuk bahan B3 ini.</p> */}
              {/* Buttons */}
	      <div className="flex justify-end gap-3 mt-4">
                <Button type="submit" color="primary">
                  Submit
                </Button>
                <Button onPress={handleCloseUpdateModal} variant="faded" color="danger">
                  Batal
                </Button>
              </div>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenHapusModal} onClose={handleCloseHapusModal}>
        <ModalContent>
          <ModalHeader>Form Penghapusan Stok B3</ModalHeader>
          <ModalBody>
            <div className="rounded-md border border-line-strong p-3 text-sm">
              <p className="font-semibold mb-2">Bahan B3 yang akan dihapus</p>
              <div className="grid grid-cols-3 gap-y-1">
                <span className="text-ink-500">CAS Number</span>
                <span className="col-span-2">: {stokDihapus?.casNumber}</span>
                <span className="text-ink-500">Nama Bahan</span>
                <span className="col-span-2">: {stokDihapus?.namaBahanKimia}</span>
                <span className="text-ink-500">Perusahaan</span>
                <span className="col-span-2">: {stokDihapus?.namaPerusahaan}</span>
                <span className="text-ink-500">Stok Terakhir</span>
                <span className="col-span-2">: {stokDihapus?.stokTerakhir} kg</span>
              </div>
            </div>

            <Textarea
              label="Alasan Penghapusan"
              labelPlacement="outside"
              placeholder="Jelaskan alasan stok B3 ini dihapus..."
              minRows={3}
              isRequired
              value={alasanHapus}
              onValueChange={setAlasanHapus}
            />

            <p className="text-ink-500 text-xs">
              Syarat: stok sudah 0 dan bahan B3 ini belum dilaporkan pada periode berjalan.
            </p>

            <p className="text-danger text-xs">
              Stok yang dihapus tidak dapat dikembalikan dari layar ini. Penghapusan beserta alasannya dicatat dan dapat dilihat Super Admin.
            </p>
          </ModalBody>
          <ModalFooter>
            <Button variant="faded" onPress={handleCloseHapusModal} isDisabled={sedangMenghapus}>
              Batal
            </Button>
            <Button color="danger" onPress={handleHapusStok} isLoading={sedangMenghapus} startContent={sedangMenghapus ? null : <TrashIcon className="size-4" />}>
              Hapus Stok
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenConfirmModal} onClose={handleCancelConfirm}>
        <ModalContent>
          <ModalHeader>Konfirmasi Submit</ModalHeader>
          <ModalBody>
            <p>Apakah Anda yakin ingin {confirmAction === "request" ? "mengajukan request stok" : "mengajukan update stok"} ini?</p>
            {formData && (
              <div className="mt-3 space-y-2">
                {confirmAction === "request" && (
                  <>
                    <p>
                      <strong>Jumlah Stok:</strong> {formData.stokRequest} kg
                    </p>
                  </>
                )}
                {confirmAction === "update" && (
                  <>
                    <p>
                      <strong>Stok Menjadi:</strong> {formData.stokBaru} kg
                    </p>
                    <p>
                      <strong>Catatan:</strong> {formData.notes || "Tidak ada"}
                    </p>
                  </>
                )}
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="danger" variant="light" onPress={handleCancelConfirm}>
              Batal
            </Button>
            <Button color="primary" onPress={executeSubmit}>
              Ya, Submit
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </RootAdmin>
  );
}

function SearchField({ value, onChange, placeholder }) {
  return (
    <div className="w-full">
      <div className="w-80 sm:w-2/5">
        <input
          type="text"
          id="search"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className="w-full px-3 py-1 border border-line-strong rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        />
      </div>
    </div>
  );
}
